module.exports = __webpack_public_path__ + "media/promo/lum2021/images/1st-2987354db10826000c05310c2982e1a1.jpg";